module.exports = __webpack_public_path__ + "static/media/masonry-1.07a51294.png";